import PersonOffIcon from '@mui/icons-material/PersonOff';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { unknownUserMessage } from './unknown-user-message';

/**
 * Fallback UI when a user cannot be loaded: PersonOff icon + muted unknown-user label.
 * Uses the same inline icon+text pattern as UserLabel so it aligns with surrounding copy.
 */
export function UnknownUserLabel() {
  const { $t } = useIntl();

  return (
    <>
      <PersonOffIcon sx={{ fontSize: 16, mt: '-3px', mr: 0.5, color: 'text.disabled' }} />
      <Box component="span" sx={{ color: 'text.disabled', fontWeight: 'regular' }}>
        {$t(unknownUserMessage)}
      </Box>
    </>
  );
}
